import { createSelector } from "reselect";
import get from "lodash/get";
import filter from "lodash/filter";

import { isPortingUserSelector } from "../authInfo";
import { userLineNumberSelector } from "../userKYCDetails";

const connectionDetailsDomain = state =>
  get(state, "form.ConnectionDetailsForm.values", {});

const connectionDetailSimConfig = state => get(state, "api.simConfig.data", {});

// ***************************************************************
// ************** ConnectionDetailsForm selectors ******************
// ***************************************************************

export const connectionDetailsSelector = createSelector(
  connectionDetailsDomain,
  connectionDetails => connectionDetails
);
export const simTypeSelector = createSelector(
  connectionDetailsDomain,
  ({ sim_type }) => sim_type
);
export const contractTypeSelector = createSelector(
  connectionDetailsDomain,
  ({ number_type }) => number_type
);

export const isSwitchActiveLineSelector = createSelector(
  connectionDetailsDomain,
  ({ switch_active_line }) => switch_active_line === "true"
);

export const hasActiveLineSelector = createSelector(
  userLineNumberSelector,
  lineNumbers => lineNumbers?.length > 0
);

export const isPortingUserWithPortingNumberSelector = createSelector(
  isPortingUserSelector,
  isSwitchActiveLineSelector,
  hasActiveLineSelector,
  (isPortingUser, isSwitchActiveLine, hasActiveLine) => {
    return isPortingUser && isSwitchActiveLine && hasActiveLine;
  }
);

export const accountPortInDetailsSelector = createSelector(
  connectionDetailsDomain,
  isPortingUserWithPortingNumberSelector,
  (
    { port_number, mnp_reservation_number, mnp_expiry_date },
    isPortingUserWithPortingNumber
  ) => ({
    switchActiveLine: isPortingUserWithPortingNumber,
    portInNumber: get(port_number, "value"),
    mnpReservationNumber: mnp_reservation_number,
    mnpExpiryDate: get(mnp_expiry_date, "value")
  })
);

export const isDeviceEsimCompatibleSelector = createSelector(
  connectionDetailsDomain,
  connectionDetails => {
    return get(connectionDetails, "mobile_device.esim_enable", false);
  }
);

export const simConfigSelector = createSelector(
  connectionDetailSimConfig,
  addSimConfigData => addSimConfigData
);

export const simTypesListSelectorNew = createSelector(
  connectionDetailSimConfig,
  simSettings => {
    let simTypes = get(simSettings, "inventory.result.simTypes", []);
    // swap the array
    // if (simTypes.length === 2) simTypes = [simTypes[1], simTypes[0]];
    const items = simTypes.reduce((acc, item) => {
      let itemName =
        item?.name === "physical_sim" ? item?.name.toUpperCase() : "E_SIM";
      return [...acc, { ...item, label: `label_${itemName}`, value: itemName }];
    }, []);
    return filter(items, item => item.enabled);
  }
);
// ***************************************************************
// ************** ConnectionDetailsForm makeSelect *****************
// ***************************************************************

export const makeSelectConnectionDetailsForm = () => connectionDetailsSelector;
export const makeSelectSimType = () => simTypeSelector;
export const makeSelectContractType = () => contractTypeSelector;
export const makeSelectIsPortingUserWithPortingNumber = () =>
  isPortingUserWithPortingNumberSelector;
export const makeSelectIsDeviceEsimCompatible = () =>
  isDeviceEsimCompatibleSelector;
export const makeSelectGetSimConfigSettings = () => simConfigSelector;
export const makeSelectSimTypesListNew = () => simTypesListSelectorNew;
